import Stack from "@mui/material/Stack";
import React, { FC } from "react";
import DraftEditor from "shared/components/DraftEditor";
import ContentSection from "shared/components/Drawer/components/ContentSection";
import TextField from "shared/components/Form/TextField";
import { COLOR_BLACK } from "shared/theme/colors";
import { useFaqDetails } from "../../../../context";

const General: FC = () => {
  const { questionInput, editorContent, handleEditorChange } = useFaqDetails();

  return (
    <ContentSection title="General">
      <Stack spacing={2}>
        <TextField
          id="question"
          label="Question*"
          placeholder="Click here to edit text"
          fullWidth
          required
          value={questionInput?.input.value}
          onChange={(e) => questionInput?.setValue(e.target.value)}
          errors={questionInput?.input.errors}
          labelColor={COLOR_BLACK}
        />
        <DraftEditor
          content={editorContent}
          label="Answer*"
          onChange={handleEditorChange}
          placeholder="Click here to edit text"
          hasHeadingToolbars
          hasListToolbars
          hasImageUpload
          hasVideoEmbed
          entityName="faq"
        />
      </Stack>
    </ContentSection>
  );
};

export default General;
